

class AppURL {
  static BaseURL = "https://backend.chrisalphatech.com/api";  
  static UserLogin = this.BaseURL+"/login";
   static UserData = this.BaseURL+"/user";
  static UserRegister = this.BaseURL+"/register"
 static UserForgetPassword = this.BaseURL+"/forgetpassword"
  static UserResetPassword = this.BaseURL+"/resetpassword"

  static VisitorDetails = this.BaseURL + "/getvisitor";

  static PostContact = this.BaseURL+"/postcontact"


   static PostSubscribe = this.BaseURL + "/postsubscribe"
   static PostQuote = this.BaseURL + "/requestquote"

  static AllSiteInfo = this.BaseURL+"/allsiteinfo"
  static AllCategoryDetails = this.BaseURL+"/allcategory"
  static Postjob = this.BaseURL+"/postjob"

  
}

export default AppURL;
